module.exports = __webpack_public_path__ + "img/1-2.676b9bc4.svg";